<mat-form-field>
  <mat-label>{{  label || 'Select Manufacturer' }}</mat-label>
  <mat-select #manufacturerSelect>
    @for (manufacturer of manufacturers; track manufacturer) {
      <mat-option
        value="{{manufacturer.manufacturer_id}}">
        {{ manufacturer.manufacturer_name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
